import { render, staticRenderFns } from "./wrongAnalysis.vue?vue&type=template&id=3cfabb4b&scoped=true&"
import script from "./wrongAnalysis.vue?vue&type=script&lang=js&"
export * from "./wrongAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./wrongAnalysis.vue?vue&type=style&index=0&id=3cfabb4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfabb4b",
  null
  
)

export default component.exports